// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__rhxVg","secondary":"button_secondary__2PH98"};